export { default } from "./src/product-card-block";

export type { UniformProductCardBlockProps } from "./src/product-card-block";
